export function buildAssignmentOnlyPayload(form: {
  assignmentGroupId?: string | null;
  assignmentGroup?: string | null;
  assignedTo?: string | null;
}): { assignmentGroupId: string | null; assignedTo: string | null } {
  return {
    assignmentGroupId: form.assignmentGroupId ?? form.assignmentGroup ?? null,
    assignedTo: form.assignedTo ?? null,
  };
}

/** Applied to non-assignment sections during assignment-only edit mode */
export const ASSIGNMENT_ONLY_LOCK_CLASS =
  'pointer-events-none [&_input]:bg-gray-100 [&_input]:text-gray-600 [&_select]:bg-gray-100 [&_select]:text-gray-600 [&_textarea]:bg-gray-100';
